export enum Profile {
    Profile0 = 0,
    Profile1 = 1,
    Profile2 = 2,
    Profile3 = 3,
    Profile4 = 4,
    Profile5 = 5,
    Profile6 = 6,
    Profile7 = 7,
    Profile8 = 8,
    Profile9 = 9,
    Profile10 = 10,
    Profile11 = 11,
    Profile12 = 12,
    Profile13 = 13,
    Profile14 = 14,
    Profile16 = 16,
    Profile17 = 17,
    Profile71 = 71,
    Tube = 'tube',
    Sinterring = 'sinterring',
    SinterringAxial = 'sinterringAxial',
}

export enum VisibleProfileProfiles {
    Profile0 = 0,
    Profile1 = 1,
    Profile2 = 2,
    Profile3 = 3,
    Profile4 = 4,
    Profile5 = 5,
    Profile6 = 6,
    Profile7 = 7,
    Profile9 = 9,
    Profile10 = 10,
    Profile11 = 11,
    Profile12 = 12,
    Profile13 = 13,
    Profile14 = 14,
    Profile16 = 16,
    Profile17 = 17,
    Profile71 = 71,
}

export enum RingSizeStandard {
    CUSTOM_WIDTH = 'CUSTOM_WIDTH',
    ENGLAND = 'ENGLAND',
    USA_CANADA = 'USA_CANADA',
    SWITZERLAND = 'SWITZERLAND',
    DIAMETER = 'DIAMETER',
}

export enum TubeRingSizeStandard {
    CUSTOM_WIDTH = 'CUSTOM_WIDTH',
    DIAMETER = 'DIAMETER',
}

export enum AxialSinterringRingSizeStandard {
    CUSTOM_WIDTH = 'CUSTOM_WIDTH',
}

export enum EdgeType {
    NO_EDGE = 'NO_EDGE',
    ROUND = 'ROUND',
    BEVEL = 'BEVEL',
}

export enum MoldType {
    NONE = 'NONE',
    PLAN = 'PLAN',
    BOMBED = 'BOMBED',
}

export enum RingType {
    PROFILERING = 'PROFILERING',
    SINTERRING = 'SINTERRING',
    SINTERRING_AXIAL = 'SINTERRING_AXIAL',
    TUBE = 'TUBE',
}

export enum RingQuantity {
    SINGLERING = 'SINGLERING',
    PAIRRING = 'PAIRRING',
}

export const defaultRingTypeOptions = [
    {
        label: 'profileRing',
        id: RingType.PROFILERING,
    },
    {
        label: 'sinterRing',
        id: [RingType.SINTERRING, RingType.SINTERRING_AXIAL],
    },
]

export enum CostEnum {
    FORM,
    METAL,
    TOTAL,
}

export type RingIdentifier = 'ring1' | 'ring2'
export type RingPreset = 'male' | 'female'

export enum GrooveType {
    UGroove,
    VGroove,
}

export type Groove = {
    position: number
    width: number
    depth?: number
    depthFromTheTop?: number
}

export type Slice = {
    size: number
    alloyName: string
    widthOversize: number
    heightOversize: number
}

export type Dimensions = {
    activeAlloy: string
    width: number
    height: number
    diameter: number
    moldOuter: number
    moldInner: number
    moldTypeInner: MoldType
    edgeOuter: number
    edgeInner: number
    radiusInner: number
    radiusOuter: number
    edgeTypeOuter: EdgeType
    edgeTypeInner: EdgeType
    decreaseWall: number // Abnahme Wand
    sideHeight: number // Seitenwand
    slantAngle: number
    grooves: Array<Groove>
    grooveType: GrooveType | null
    slices: Array<Slice>
    ringSizeStandard: RingSizeStandard
    heightOversize?: number
}

export interface RingConfiguration {
    dimensions: Dimensions
    visible: boolean
    activeProfile: Profile
    favoriteProfileOrigin?: { name: string; favoriteProfileConfiguration: RingConfiguration; favoriteProfile?: any }
}

export type Validation<T> = Partial<Record<keyof T, any>>

export interface Division {
    label: string
    id: DivisionId
    default?: boolean
}

export type DivisionId = 'custom' | '1:1' | '1:2' | '2:1' | '1:3' | '3:1' | '1:1:1' | '2:1:2' | '1:2:1' | '2:1:1' | '1:1:1:1' | '2:1:2:1:2' | '1:1:1:1:1'

export const normalSinterringDivisionsMap: Division[][] = [
    [],
    [
        { label: '1:1', id: '1:1', default: true },
        { label: '1:2', id: '1:2' },
        { label: '2:1', id: '2:1' },
        { label: '1:3', id: '1:3' },
        { label: '3:1', id: '3:1' },
    ],
    [
        { label: '1:1:1', id: '1:1:1' },
        { label: '2:1:2', id: '2:1:2' },
        { label: '1:2:1', id: '1:2:1', default: true },
        { label: '2:1:1', id: '2:1:1' },
    ],
    [{ label: '1:1:1:1', id: '1:1:1:1', default: true }],
    [
        { label: '1:1:1:1:1', id: '1:1:1:1:1', default: true },
        { label: '2:1:2:1:2', id: '2:1:2:1:2', default: true },
    ],
    [{ label: 'custom', id: 'custom', default: true }],
]

export const sinteringAxialDivision: Division = {
    label: '1:1',
    id: '1:1',
    default: true,
}

export const axialSinterringDivisionsMap: Division[][] = [[], [sinteringAxialDivision]]

export const customDivision: Division = {
    label: 'custom',
    id: 'custom',
    default: true,
}

export const defaultAlloyMaterialName = '116-585'

export type APIError = {
    response: {
        data: {
            detail: string
        }
    }
}
